"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _auth_button = _interopRequireDefault(require("../../ui/button/auth_button"));
var l = _interopRequireWildcard(require("../../core/index"));
var _actions = require("../../quick-auth/actions");
var _index2 = require("../../connection/social/index");
var _event = require("./event");
var _index3 = require("../../connection/database/index");
var _actions2 = require("../../connection/database/actions");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var SocialButtonsPane = /*#__PURE__*/function (_React$Component) {
  _inherits(SocialButtonsPane, _React$Component);
  var _super = _createSuper(SocialButtonsPane);
  function SocialButtonsPane() {
    _classCallCheck(this, SocialButtonsPane);
    return _super.apply(this, arguments);
  }
  _createClass(SocialButtonsPane, [{
    key: "handleSubmit",
    value: function handleSubmit(lock, provider, isSignUp) {
      if (isSignUp && !(0, _index3.termsAccepted)(lock)) {
        return (0, _actions2.signUpError)(lock.get('id'), {
          code: 'social_signup_needs_terms_acception'
        });
      }
      (0, _event.emitFederatedLoginEvent)(this.props.lock, provider, isSignUp);
      return (0, _actions.logIn)(l.id(this.props.lock), provider);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      // TODO: i don't like that it receives the instructions tanslated
      // but it also takes the t fn
      var _this$props = this.props,
        instructions = _this$props.instructions,
        labelFn = _this$props.labelFn,
        lock = _this$props.lock,
        showLoading = _this$props.showLoading,
        signUp = _this$props.signUp;
      var headerText = instructions || null;
      var header = headerText && /*#__PURE__*/_react.default.createElement("p", null, headerText);
      var themes = (0, _index2.authButtonsTheme)(lock);
      var buttons = (0, _index2.socialConnections)(lock).map(function (x) {
        var buttonTheme = themes.get(x.get('name'));
        var connectionName = buttonTheme && buttonTheme.get('displayName');
        var primaryColor = buttonTheme && buttonTheme.get('primaryColor');
        var foregroundColor = buttonTheme && buttonTheme.get('foregroundColor');
        var icon = buttonTheme && buttonTheme.get('icon');
        return /*#__PURE__*/_react.default.createElement(_auth_button.default, {
          key: x.get('name'),
          label: labelFn(signUp ? 'signUpWithLabel' : 'loginWithLabel', connectionName || (0, _index2.displayName)(x)),
          onClick: function onClick() {
            return _this.handleSubmit(lock, x, signUp);
          },
          strategy: x.get('strategy'),
          primaryColor: primaryColor,
          foregroundColor: foregroundColor,
          icon: icon
        });
      });
      var loading = showLoading && /*#__PURE__*/_react.default.createElement("div", {
        className: "auth0-loading-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "auth0-loading"
      }));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "auth-lock-social-buttons-pane"
      }, header, /*#__PURE__*/_react.default.createElement("div", {
        className: "auth0-lock-social-buttons-container"
      }, buttons), loading);
    }
  }]);
  return SocialButtonsPane;
}(_react.default.Component);
exports.default = SocialButtonsPane;
SocialButtonsPane.propTypes = {
  instructions: _propTypes.default.any,
  labelFn: _propTypes.default.func.isRequired,
  lock: _propTypes.default.object.isRequired,
  showLoading: _propTypes.default.bool.isRequired,
  signUp: _propTypes.default.bool.isRequired,
  e: _propTypes.default.bool
};
SocialButtonsPane.defaultProps = {
  showLoading: false,
  e: false
};
